import { ca } from '@cian/analytics';
import { IDeveloper } from '../../../types/developer/developer';
import { createGaUser } from '../../../utils/analytics/createGaUser';
import { IUser } from '../../../types/user/user';
import { createLabel } from '../../../utils';
import { ICallbackParams, TCallbackPlace } from '../../../types/callback';

export function trackShowPhone(action: string) {
  return (developer: IDeveloper) =>
    ca('eventSite', {
      name: 'oldevent',
      category: 'Phones',
      action,
      label: createLabel(developer.id),
      useLastProducts: true,
    });
}

interface ITrackCallbackPopupOpenParams {
  developer: IDeveloper;
  place: TCallbackPlace;
}

export function trackCallbackPopupOpen(params: ITrackCallbackPopupOpenParams) {
  const { developer, place } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: `CallBack_popup_open_${place}`,
    label: createLabel(developer.id),
    useLastProducts: true,
  });
}

interface ITrackSendCallbackRequestParams {
  developer: IDeveloper;
  parameters: ICallbackParams;
  place: TCallbackPlace;
  user: IUser;
}

export function trackSendCallbackRequest(params: ITrackSendCallbackRequestParams) {
  const {
    developer,
    parameters: { customerPhone, callRightNow, time },
    place,
    user,
  } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: `CallBack_popup_send_${place}`,
    label: createLabel(developer.id),
    useLastProducts: true,
    user: {
      ...createGaUser(user),
      extra: {
        phone: customerPhone,
        call_time: time,
        call_now: callRightNow,
      },
    },
  });
}
